import { Stack, Tooltip, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { InfoOutlined } from '@mui/icons-material';
import { ReactNode } from 'react';
import { useMyAssortmentTFunction } from '@retail/my-assortment/i18n';

interface Props {
  title: string;
  helpText?: string;
  isEmpty: boolean;
  accent?: 'success' | 'default';
  children: ReactNode;
}

export function SupplierPrioritySection({
  title,
  helpText,
  isEmpty,
  accent = 'default',
  children,
}: Props) {
  const t = useMyAssortmentTFunction();

  return (
    <Stack>
      <Stack
        direction="row"
        alignItems="center"
        gap={1}
        height={44}
        px={2}
        sx={(theme) => ({
          bgcolor:
            accent === 'success'
              ? theme.vars
                ? `rgba(${theme.vars.palette.success.mainChannel} / 0.08)`
                : alpha(theme.palette.success.main, 0.08)
              : theme.vars.palette.action.hover,
        })}
      >
        <Typography variant="subtitle2">{title}</Typography>
        {helpText && (
          <Tooltip title={helpText} placement="top" arrow>
            <InfoOutlined fontSize="inherit" sx={{ color: 'text.secondary' }} />
          </Tooltip>
        )}
      </Stack>
      <Stack px={2} py={2} gap={1} flexGrow={1}>
        {isEmpty ? (
          <Typography variant="body2" color="text.secondary" fontStyle="italic">
            {t('myAssortment.priority.noSuppliers')}
          </Typography>
        ) : (
          children
        )}
      </Stack>
    </Stack>
  );
}
